module.exports = {"connect_with":"Oder verknüpfe mit","success":{"title":"Verbindung zu {{ providerName }} erfolgreich","content":"Nur noch ein paar Fragen um loszulegen. Fast fertig!","continue":"Fortsetzen"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/de/social.json
// module id = 508
// module chunks = 248 1664